import { Component, ElementRef, EventEmitter, HostBinding, HostListener, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { InputBase, LabelPosition } from '../input-base';

@Component({
  selector: 'input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class InputFileComponent extends InputBase implements OnInit {
  @HostBinding('class') class = 'form-group';
  @ViewChild('inputElement', { static: true }) inputElement?: ElementRef;
  @Output() change = new EventEmitter<Event>();
  @Input() hostClass: string = ""; 
  @Input() labelPosition: LabelPosition = "top";
  @Input() controlName: string | null = null;
  @Input() disabled?: string;
  @Input() icon: string = "";
  @Input() label: string = "";
  @Input() labelInfo: string = "";
  @Input() labelClass?: string;
  @Input() bold: boolean = false;
  @Input() value: any = "";
  @Input() loading: boolean = false;
  @Input() source?: any;
  @Input() path?: string;
  @Input() required?: string;
  @Input() accept?: string | string[];
  @Input() form?: FormGroup;
  @Input() set control(value: AbstractControl | undefined) {
    this._control = value;
  }
  get control(): AbstractControl | undefined {
    return this.getControl();
  }
  @Input() set size(value: number) {
    this.setSize(value); 
  }
  get size(): number {
    return this.getSize(); 
  }

  constructor(public injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  public get acceptValue(): string | undefined {
    return typeof this.accept == "string" ? this.accept : this.accept?.map(x => "." + x).join(",");
  }

  public onInputFileChange(event: Event) {
    let self = this;
    (async () => {
      self.value = await self.asBase64;
      if(self.control) self.control.setValue(self.value);
    })();
  }

  public get asBase64(): Promise<string | null> {
    let files: FileList = this.inputElement?.nativeElement?.files;
    if(files.length) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = error => reject(error);
      });
    } else {
      return Promise.resolve(null);
    }
 }
}
